<!-- <app-news-header *ngIf="constant.IsVerified" (GameUrl)="getGameUrl($event)"></app-news-header> -->
<ng-container *ngIf="transform && constant.IsVerified">
  <iframe id="gameIFrame" *ngIf="constant.LanguageChange && constant.ModeChange && constant.GameChange;else disabledBack;" scroll="no" sandbox="allow-same-origin allow-scripts allow-forms" [src]="transform"
    style="width: 100%;" frameborder="0" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"
    (load)="iframeLoded()"></iframe>
    <ng-template #disabledBack>
      <div class="background-disabled">
        <div class="loader-new-for-iframe p-0 position-absolute">
          <img src="assets/images/Mobile-Logo.gif" alt="loader">
        </div>
      </div>
    </ng-template>
  <app-chips-setting [minStack]="10" [maxStack]="10000"></app-chips-setting>
</ng-container>
<ng-container *ngIf="!IsVerified">
  <div class="error-container" style="position: unset !important;">
    <!-- <div class="row">
      <div class="col-sm-12">
        <div class="loader">
          <img src="assets/images/logo/supernowa-logo.png">
          <img src="assets/images/logo/supernowa-logo-bk.png" alt="Supernowa" title="Supernowa">
          <img src="assets/images/victor-logo-star.png">
        </div>
      </div>
    </div> -->
    <div class="row">
      <div class="col-sm-12 invalid"> {{'GameNotAvailable'| translate}} </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="!constant.IsVerified">
  <app-error [errorMessage]="DisplayMessage" [navigateLink]="constant.LoginLink"></app-error>
</ng-container>
<!-- Rules Pop Up End -->
<ng-container *ngIf="constant.isIfreameLodded">
  <div class="background-disabled">
    <div class="loader-new-for-iframe p-0 position-absolute">
      <img src="assets/images/Mobile-Logo.gif" alt="loader">
    </div>
  </div>
</ng-container>
